import { t } from '@kb/i18n';
import { useMutation } from '@ocp/graphql-client';
import { notifyDanger, notifySuccess } from '@ocp/notifications';
import i18n from '../i18n';
export const DELETE_CONTENT_MUTATION = `
  mutation deleteContent($classNameId: Long, $classPk: Long) {
    deleteContent(classNameId: $classNameId, classPk: $classPk)
  }
`;
const useDeleteContentMutation = (onCompleted) => {
    return useMutation(DELETE_CONTENT_MUTATION, {
        onCompleted: () => {
            onCompleted();
            notifySuccess(t(i18n.YOUR_REQUEST_COMPLETED_SUCCESSFULLY));
        },
        // TODO: Move common rules of error processing to apollo client level.
        onError: (data) => {
            var _a, _b;
            const [error] = data.graphQLErrors;
            let message;
            if (((_a = error === null || error === void 0 ? void 0 : error.extensions) === null || _a === void 0 ? void 0 : _a.key) === 'PROTECTED_CONTENT_ERROR_$reason') {
                message = t(i18n.PROTECTED_CONTENT_ERROR_$reason, {
                    reason: ((_b = error === null || error === void 0 ? void 0 : error.extensions) === null || _b === void 0 ? void 0 : _b.variables).find((v) => v.name === 'reason').value,
                });
            }
            else {
                console.error(data);
                message = t(i18n.ERROR_IS_OCCURED);
            }
            notifyDanger(message);
        },
    });
};
export default useDeleteContentMutation;
